import React, { useContext, useEffect, useState, useRef } from "react";
import { UrlContext } from "../contexts/UrlContext";
import AddNewEmail from "../components/ProjectDetails/addNewEmail";
import DragAndDrop from "../components/SharedProfiles/drag&drop";
import ReactQuill from 'react-quill';
import 'react-quill/dist/quill.snow.css'; // Quill's styles

const EmailComposer = ({ emailDetails, onClose, onSend }) => {
  const [modifiedSubject, setModifiedSubject] = useState("");
  const [modifiedBody, setModifiedBody] = useState("");
  const [modifiedTo, setModifiedTo] = useState("");
  const [modifiedFrom, setModifiedFrom] = useState([]);
  const [modifiedBCC, setModifiedBCC] = useState([]);
  const [expertIDs, setExpertIDs] = useState([]);
  const [modifiedCC, setModifiedCC] = useState("");
  const [emailType, setEmailType] = useState("");
  const [language, setLanguage] = useState("");
  const [engBody, setEngBody] = useState("");
  const [germBody, setGermBody] = useState("");
  const [engSubject, setEngSubject] = useState("");
  const [germSubject, setGermSubject] = useState("");
  const [enableSignature, setEnableSignature] = useState(null);
  const [fromCustomizedList, setFromCustomizedList] = useState(false);
  const [thankyouEmail, setThankyouEmail] = useState(false)
  const [existingTemplateList, setExistingTemplateList] = useState({});
  const [defaultTemplateData, setDefaultTemplateData] = useState({});
  const [selectedOption, setSelectedOption] = useState(null);
  const [fromEmail, setFromEmail] = useState(false)
  const modBody = useRef(null);
  const [base64Strings, setBase64Strings] = useState([]);
  const [hasAttachment, setHasAttachment] = useState(false);
  const [templates, setTemplates] = useState(null);
  const [openDragDrop, setOpenDragDrop] = useState(false);
  const [hasBcc, setHasBcc] = useState(false);
  const [htmlContentToDisplay, setHtmlContentToDisplay] = useState("");
  const tokenObj = localStorage.getItem("eph-token");
  const { API_URL } = useContext(UrlContext);
  const previewRef = useRef(null);

  useEffect(() => {
    // Apply inline styles to all img elements inside the rendered HTML
    adjustSignature()
    
  }, [htmlContentToDisplay, enableSignature]);

  const adjustSignature = () => {
    if(previewRef.current){
      const imgs = previewRef.current.querySelectorAll("img");
      const lastThreeImgs = Array.from(imgs).slice(-3);
      lastThreeImgs.forEach((img, index) => {
        if(index!==1){
          console.log(img)
          img.style.width = "auto";
          img.style.height = "auto";
          img.style.maxWidth = "100%";
          img.style.maxHeight = "1000px"; // Adjust as needed
        } else {
          img.style.width = "auto";
          img.style.height = "auto";
          img.style.maxWidth = "95px";
          img.style.maxHeight = "150px"; // Adjust as needed
          img.style.marginLeft = '2px'
        }
        
      });

    }
  }



  useEffect(() => {
    setModifiedFrom(emailDetails.from);
    setModifiedBody(emailDetails.body);
    setModifiedSubject(emailDetails.subject);
    setEnableSignature(emailDetails.enableSignature);
    if (emailDetails.contactTopic === "General query about availability") {
      setEmailType("navbar");
      setLanguage("English");
      setEngBody(emailDetails.body);
      setGermBody(emailDetails.body_germ);
      setEngSubject(emailDetails.subject);
      setGermSubject(emailDetails.subject_germ);
    } else if (emailDetails.contactTopic.startsWith("CL")) {
      setLanguage("English");
      setEngBody(emailDetails.body);
      setGermBody(emailDetails.body_germ);
      setEngSubject(emailDetails.subject);
      setFromCustomizedList(true);
    } else if (emailDetails.subject === "expertpowerhouse: Compensation Details & Thank you!") {
      setThankyouEmail(true)
      setEngBody(emailDetails.body);
      setGermBody(emailDetails.body_germ);
      setEngSubject(emailDetails.subject);
      setGermSubject(emailDetails.subject_germ);
    }
    else {
      setEmailType("email");
      console.log(emailDetails)
      if('cc' in emailDetails){
        setModifiedCC(emailDetails.cc)
      } else {
        setModifiedCC([])
      }
    }
    if('templates' in emailDetails){
      setFromEmail(true)
      setExistingTemplateList(emailDetails.templates);
      setTemplates(emailDetails.templates);
      setDefaultTemplateData(emailDetails.currentTemplate);
      if(emailDetails.currentTemplate){
        if('email_body' in emailDetails.currentTemplate){
          setSelectedOption(emailDetails.currentTemplate.id)
          setModifiedBody(emailDetails.currentTemplate.email_body)
          setModifiedSubject(emailDetails.currentTemplate.email_sub)
        } else {
          if (emailDetails.currentTemplate.cons_exp === "con" || emailDetails.currentTemplate.cons_exp === "int") {
            var defTemplateEnglish = emailDetails.body

            var emailBody =
                emailDetails.currentTemplate.description +
                "<br>" +
                "Details:<br />" +
                "Project Start Date: " +
                emailDetails.currentTemplate.projStartDate +
                "<br />" +
                "Project Duration: " +
                emailDetails.currentTemplate.projDuration +
                "<br />" + 
                "Work mode: " +
                emailDetails.currentTemplate.empType +
                "<br />" + 
                "Industry: " +
                emailDetails.currentTemplate.industry;
            defTemplateEnglish = defTemplateEnglish.replace(
                "Email_body",
                emailBody
              );
            setModifiedBody(defTemplateEnglish)
          } else {
            var defTemplateEnglish = emailDetails.body;
            console.log(defTemplateEnglish)
            var emailBody =
            emailDetails.currentTemplate.description +
              "<br>" + 
              "Details:<br />" + 
              "Project Start Date: " +
              emailDetails.currentTemplate.projStartDate +
              "<br />" + 
              "Project Duration: " +
              emailDetails.currentTemplate.projDuration +
              "<br />" + 
              "Work mode: " +
              emailDetails.currentTemplate.empType +
              "<br />" + 
              "Industry: " +
              emailDetails.currentTemplate.industry +
              "<br /><br />" + 
              "This would be an attractively paid 1-hour discussion by phone.";
            defTemplateEnglish = defTemplateEnglish.replace(
              "Email_body",
              emailBody
            );
            setModifiedBody(defTemplateEnglish)
          }
          
        }
        
      }
    }
  }, [emailDetails]);

  useEffect (() => {
    if (emailDetails.to) {
      if('bulkEmail' in emailDetails && emailDetails.bulkEmail){
        setModifiedTo(emailDetails.to)
        setExpertIDs(emailDetails.expertID)
      } else {
        setModifiedTo((prevList) => [...prevList, emailDetails.to]);
      }
    } else {
      setModifiedTo([]);
    }
    if('cc' in emailDetails){
      setModifiedCC(emailDetails.cc)
    } else {
      setModifiedCC([])
    }
  }, []);

  function getDivInnerHTML() {
    const div = document.querySelector(".emailComposerBody");
    return div.innerHTML;
  };

  const handleSend = () => {
    onSend({
      to: modifiedTo,
      from: modifiedFrom,
      bcc_email: modifiedBCC,
      cc_email: modifiedCC,
      subject: modifiedSubject,
      body: modifiedBody,
      expertID: ('bulkEmail' in emailDetails && emailDetails.bulkEmail) ? expertIDs : emailDetails.expertID,
      username: emailDetails.username,
      contactTopic: emailDetails.contactTopic,
      enableSignature: enableSignature,
      attachment: base64Strings,
    });
  };


  // function to remove attachment
  function handleRemoveFile(index) {
    const updatedBase64Strings = [...base64Strings];
    updatedBase64Strings.splice(index, 1);
    setBase64Strings(updatedBase64Strings);
    if (updatedBase64Strings.length === 0) {
      setHasAttachment(false);
    }
  }

  // API for fetching user signature
  const getSignature = async () => {
    if (tokenObj) {
      const token = JSON.parse(tokenObj).value;
      const url = `${API_URL}account-settings`;

      fetch(url, {
        method: "GET",
        headers: {
          "Content-Type": "application/json",
          "x-access-token": token,
        },
      })
        .then((res) => res.json())
        .then((data) => {
          const signature = data.signature
            .replace(
              "{{name}}",
              `${data.user.sigtitle} ${data.user.sigfirstname} ${data.user.siglastname}`
            )
            .replace("{{designation}}", data.user.config)
            .replace("{{contactNumber}}", data.user.path_z);

          setHtmlContentToDisplay(signature);
        })
        .catch((err) => {
          console.log(err);
        });
    } else {
      console.error("No token found in localStorage");
    }
  };

  useEffect(() => {
    getSignature();
  }, []);

  // Function to handle emails
  const handleSendToChange = (attendees) => {
    setModifiedTo(attendees);
    if('bulkEmail' in emailDetails && emailDetails.bulkEmail){
      const newTo = emailDetails.expertID.filter((expert) => attendees.includes(expert[1]));
      setExpertIDs(newTo)
    }
  };
  const handleCcMailChange = (attendees) => {
    setModifiedCC(attendees);
  };
  const handleBccMailChange = (attendees) => {
    setModifiedBCC(attendees);
  };

  // Function to handle subject change
  const handleSubjectChange = (e) => {
    setModifiedSubject(e.target.value);
  };

  const handleBodyChange = (e) => {
    setModifiedBody(e);
  };

  return (
    <>
      <div className="decline-wrapper">
        <div className="flex-container-decline-profile" style={{width: "98%", height: "73%", padding: "0px", border: "none", overflowY: "hidden"}}>
          <div className="flex-item-decline-profile-header" style={{flex: "2%", background: "#365561"}}>
            <div style={{display: "flex", flexDirection: "row"}}>
              <p style={{fontSize: "16px", fontWeight: "500", color: "white", marginLeft: "5px"}}>{'bulkEmail' in emailDetails && emailDetails.bulkEmail ? modifiedTo.length + " separate emails will be sent" : "Email"} | </p>
              {emailType === "navbar" || fromCustomizedList || thankyouEmail ? (
                <>
                  <select
                    style={{outline: "none", border: "none", background: "none", color: "white", fontSize: "16px", fontWeight: "500", cursor: "pointer"}}
                    value={language}
                    onChange={(e) => {
                      setLanguage(e.target.value);
                      if (e.target.value === "English") {
                        setModifiedBody(engBody);
                        setModifiedSubject(engSubject);
                      } else {
                        setModifiedBody(germBody);
                        if (!fromCustomizedList) {
                          setModifiedSubject(germSubject);
                        }
                      }
                    }}
                  >
                    <option style={{color: "black"}} value="English">EN</option>
                    <option style={{color: "black"}} value="German">DE</option>
                  </select>
                  <p
                    style={{
                      fontSize: "16px",
                      fontWeight: "500",
                      color: "white",
                    }}
                  >
                    {" "}
                    |{" "}
                  </p>
                </>
              ) : (
                <></>
              )}
              {templates && (
                <>
                  <select
                    style={{
                      outline: "none",
                      border: "none",
                      background: "none",
                      color: "white",
                      fontSize: "16px",
                      fontWeight: "500",
                      cursor: "pointer",
                    }}
                    defaultValue={selectedOption}
                    onChange={(e) => {
                      const selectedValue = e.target.value;
                      const selectedOption = emailDetails.templates.find(option => option.id === parseInt(selectedValue, 10));
                      setSelectedOption(parseInt(selectedValue, 10))
                      setModifiedBody(selectedOption.email_body)
                      setModifiedSubject(selectedOption.email_sub)
                    }}
                  >
                    {emailDetails.templates.map(option => (
                        <option
                          key={option.id}
                          value={option.id}
                          title={option.email_body}
                          style={{color: "black"}}
                        >
                          {option.created_by} : {option.just_in_case} on {option.created_date}
                        </option>
                    ))}
                  </select>
                </>
              )}
            </div>
            <i
              class="fa-solid fa-xmark"
              style={{
                marginRight: "5px",
                marginTop: "3px",
                color: "gray",
                cursor: "pointer",
              }}
              onClick={onClose}
            />
          </div>
          <div className="flex-item-sugest-time-slot-email" style={{flex: "98%"}}>
            <div className="flex-container-emil" style={{ display: "flex", flexDirection: "column", marginTop: "10px"}}>

              <div className="flex-item-email-action" style={{flex: "20%", borderBottom: "1px solid lightgrey"}}>
                <div className="flex-container-email-action-container" style={{ display: "flex", flexDirection: "row", marginBottom: "10px", gap: "10px", padding: "5px"}}>

                  <div className="flex-item-email-action-container-item-send" style={{flex: "5%", borderRadius: "5px", display: "flex", flexDirection: "column"}}>
                    <div 
                      className="send-button-email" 
                      style={{border: "1px solid lightgrey", borderRadius: "5px", height: hasBcc ? "70%" : "60%", textAlign: "center", display: "flex", flexDirection: "column", cursor: "pointer"}}
                      onClick={() => handleSend()}
                    >
                      <i
                        class="fa-solid fa-paper-plane"
                        style={{
                          marginTop: "15%",
                          fontSize: "30px",
                          color: modifiedTo ? "#365561" : "gray",
                        }}
                      ></i>
                      <span style={{ marginBottom: "10%" }}>Send</span>
                    </div>
                    <div
                      className="attach-button-email tooltip-count"
                      style={{ textAlign: "center", cursor: "default" }}
                    >
                      <i
                        class="fa-solid fa-paperclip fa-xl"
                        style={{
                          marginTop: "27px",
                          cursor: "pointer",
                          color: hasAttachment ? "#365561" : "grey",
                        }}
                        onClick={() => setOpenDragDrop(true)}
                      ></i>
                      {base64Strings && base64Strings.length > 0 && (
                        <div
                          style={{
                            position: "absolute",
                            top: "5px",
                            right: "15px",
                            background: "#365561",
                            color: "white",
                            borderRadius: "50%",
                            padding: "2px 6px",
                            fontSize: "12px",
                            fontWeight: "bold",
                          }}
                        >
                          {base64Strings.length}
                          <span className="tooltip-text">
                            <ul>
                              {base64Strings.map((file, index) => (
                                <li
                                  key={index}
                                  style={{
                                    display: "flex",
                                    justifyContent: "space-between",
                                    gap: "20px",
                                  }}
                                >
                                  <p>{file.name}</p>
                                  <i
                                    class="fa-solid fa-xmark"
                                    style={{
                                      marginTop: "4px",
                                      color: "red",
                                      cursor: "pointer",
                                    }}
                                    onClick={() => handleRemoveFile(index)}
                                  />
                                </li>
                              ))}
                            </ul>
                          </span>
                        </div>
                      )}
                    </div>
                  </div>

                  <div
                    className="flex-item-email-action-container-item-attendees"
                    style={{
                      flex: "5%",
                      display: "flex",
                      flexDirection: "column",
                      marginBottom: "10px",
                      gap: "10px",
                    }}
                  >
                    <div
                      style={{
                        border: "1px solid lightgrey",
                        borderRadius: "5px",
                        textAlign: "center",
                      }}
                    >
                      <p style={{ margin: "5px", fontSize: ('bulkEmail' in emailDetails && emailDetails.bulkEmail) ? "10px" : "16px" }}>{'bulkEmail' in emailDetails && emailDetails.bulkEmail ? "Multiple emails": 'To'}</p>
                    </div>
                    <div
                      className="cc-mail tooltip-shareProfile"
                      onClick={() => setHasBcc(true)}
                      style={{
                        border: "1px solid lightgrey",
                        borderRadius: "5px",
                        textAlign: "center",
                      }}
                    >
                      <p style={{ margin: "5px" }}>Cc</p>
                      <span className="tooltip-text">See Bcc?</span>
                    </div>
                    {hasBcc && (
                      <div
                        className="bcc-mail tooltip-shareProfile"
                        onClick={() => setHasBcc(false)}
                        style={{
                          border: "1px solid lightgrey",
                          borderRadius: "5px",
                          textAlign: "center",
                        }}
                      >
                        <p style={{ margin: "5px" }}>Bcc</p>
                        <span className="tooltip-text">click to hide!</span>
                      </div>
                    )}
                    <div style={{ textAlign: "center" }}>
                      <p style={{ margin: "5px" }}>Subject</p>
                    </div>
                  </div>

                  <div
                    className="flex-item-email-action-container-item-inputs"
                    style={{
                      flex: "90%",
                      display: "flex",
                      flexDirection: "column",
                      marginBottom: "10px",
                      gap: "10px",
                    }}
                  >
                    <div
                      className="input-attendees-subject"
                      style={{ outline: "none", height: "36px" }}
                    >
                      {modifiedTo && (
                        <AddNewEmail
                          handleInputChange={handleSendToChange}
                          currentEmails={modifiedTo}
                          isBulkMode={('bulkEmail' in emailDetails && emailDetails.bulkEmail)}
                        />
                      )}
                    </div>
                    <div
                      className="input-attendees-subject"
                      style={{ outline: "none", height: "36px" }}
                    >
                      {modifiedCC && (
                        <AddNewEmail
                          handleInputChange={handleCcMailChange}
                          currentEmails={modifiedCC}
                        />
                      )}
                    </div>
                    {hasBcc && (
                      <div
                        className="input-attendees-subject"
                        style={{ outline: "none", height: "36px" }}
                      >
                        {modifiedBCC && (
                          <AddNewEmail
                            handleInputChange={handleBccMailChange}
                            currentEmails={modifiedBCC}
                          />
                        )}
                      </div>
                    )}
                    {modifiedSubject && (
                      <input
                        className="input-attendees-subject"
                        value={modifiedSubject}
                        onChange={(e) => handleSubjectChange(e)}
                        style={{
                          outline: "none",
                          height: "35px",
                        }}
                      />
                    )}
                  </div>
                </div>
              </div>
              <div className="flex-item-email-body" style={{ flex: "80%" }}>
                <div style={{ padding: "5px" }}>
                  <ReactQuill
                    theme="snow"
                    value={modifiedBody}
                    onChange={(e) => handleBodyChange(e)}
                    modules={{
                      toolbar: [
                        [{ header: [1, 2, false] }],
                        ["bold", "italic", "underline", "strike"],
                        [{ list: "ordered" }, { list: "bullet" }],
                        ["link"], 
                      ],
                    }}
                    formats={["header", "bold", "italic", "underline", "strike", "list", "bullet", "link"]}
                    style={{
                      height: "380px",
                      overflowY: "auto",
                      display: "flex",
                      flexDirection: "column",
                    }}
                  />
                  <style>
                    {`
                                                .ql-editor {
                                                  padding: 5px !important;
                                                  font-size: 13px !important;
                                                  font-family: Verdana, sans-serif;
                                                }
                                                .ql-container .ql-snow .ql-hidden {
                                                  display: none !important;
                                                }
                                                .ql-toolbar.ql-snow {
                                                  position: inherit;
                                                  top: 0;
                                                  right: 24px;
                                                  padding: 3px;
                                                  display: flex; /* Arrange items in a single row */
                                                  flex-wrap: nowrap; /* Prevent wrapping of toolbar items */
                                                  gap: 10px; /* Adjust gap between items if necessary */
                                                }
                                              `}
                  </style>

                  <div>
                    <div className="custom-control custom-control-right custom-switch" style={{marginTop: "20px"}}>
                      <input
                        type="checkbox"
                        className="custom-control-input"
                        id="customSwitch1-emailComposer"
                        checked={enableSignature}
                        onChange={(e) => {
                          setEnableSignature(e.target.checked)
                          adjustSignature()
                        }}
                      />
                      <label
                        className="custom-control-label"
                        for="customSwitch1-emailComposer"
                      >
                        <p style={{fontSize: "14px", color: "grey"}}>Include Signature?</p>
                      </label>
                    </div>
                    {enableSignature && (
                      <div ref={previewRef} dangerouslySetInnerHTML={{ __html: htmlContentToDisplay }} />
                    )}
                  </div>
                </div>
              </div>
            </div>
          </div>
        </div>
      </div>

      {openDragDrop && (
        <DragAndDrop
          setOpenDragDrop={setOpenDragDrop}
          setBase64Strings={setBase64Strings}
          setHasAttachment={setHasAttachment}
        />
      )}

      {/* ------------ to fix the signature picture only for this component ------------------ */}
      {/* <style>
        {`
          div img {
            max-width: 100%;   // Ensures the image width doesn't exceed the container width
            max-height: 100%;  // Ensures the image height doesn't exceed the container height
            object-fit: contain; // Scales the image while preserving aspect ratio
          }
        `}
      </style> */}
    </>
  );
};

export default EmailComposer;
